export const CAMPAIGN_MANAGEMENT_COLUMNS = {
  VISIBILITY_MODEL: 'CAMPAIGN_MANAGEMENT_COLUMNS_VISIBILITY_MODEL',
  ORDER: 'CAMPAIGN_MANAGEMENT_COLUMNS_ORDER',
};
